module.exports = __webpack_public_path__ + "static/media/quote.0593162a.svg";